<template>
    <b-container fluid class="mt-2 px-0 pb-2">
        <b-row>
            <b-col cols="" class="">
                <b-row>
                    <b-col cols="">
                        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-0">
                            <h2 class="text-left mb-3">{{ $t('dotInspect.title') }}</h2>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <div class="data-table team-data-table table-custom-border bg-white">
                            <div class="bg-white rounded">
                                <div class="d-block text-center mt-4">
                                    <b-row class="align-items-center px-4 mb-3">
                                        <h3 class="f-18 font-weight-bold col-12 text-left mb-0">{{ $t('dotInspect.inspectionSiteSection') }}</h3>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <div class="text-left select_arrow ">
                                                <b-form-group :label="$t('dotInspect.inspectionSiteLabel')" class="text-left mb-0">
                                                    <b-form-input type="text" :placeholder="$t('dotInspect.inspectionSitePlaceholder')"
                                                        class="unit f-14" v-model="recordPayload.inspection_site"
                                                        required></b-form-input>
                                                    <p v-if="errors && errors.inspection_site" class="field-error">
                                                        {{ errors.inspection_site[0] }}
                                                    </p>
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="align-items-center px-4 mb-3 mt-5">
                                        <h3 class="f-18 font-weight-bold col-12 text-left mb-0">{{ $t('dotInspect.divisionSection') }}</h3>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <div class="text-left select_arrow ">
                                                <b-form-group :label="$t('dotInspect.divisionLabel')" class="text-left mb-0">
                                                    <v-select class="f-14" :clearable="false" :options="allDivisions"
                                                        :reduce="(option) => option.id" v-model="recordPayload.division" />
                                                    <p v-if="errors && errors.division" class="field-error">
                                                        {{ errors.division[0] }}
                                                    </p>
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="align-items-center px-4 mb-3 mt-5 d-block">
                                        <h3 class="f-18 font-weight-bold col-12 text-left mb-0">{{ $t('dotInspect.equipmentSection') }}</h3>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <div class="text-left select_arrow ">
                                                <b-form-group :label="$t('dotInspect.typeLabel')" class="text-left mb-0">
                                                    <b-form-select class="f-14" v-model="recordPayload.type"
                                                        @change="resetUnitNo()"
                                                        :options="equipmentTypeOptions">
                                                    </b-form-select>
                                                    <p v-if="errors && errors.type" class="field-error">
                                                        {{ errors.type[0] }}
                                                    </p>
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <div class="text-left select_arrow ">
                                                <label class="state">{{ $t('dotInspect.unitNoLabel') }}</label>
                                                <v-select class="bg_white w-100 f-4" v-model="recordPayload.unit_no"
                                                    :options="nameOptions" item-value="id" item-text="label"
                                                    :reduce="(option) => option.id" @search="searchAssets"
                                                    @input="setVinNo">
                                                    <span slot="no-options">
                                                        {{ $t('dotInspect.searchUnit') }}
                                                    </span>
                                                </v-select>
                                                <p v-if="errors && errors.unit_no" class="field-error">
                                                    {{ errors.unit_no[0] }}
                                                </p>
                                            </div>
                                        </b-col>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <div class="text-left select_arrow ">
                                                <b-form-group :label="$t('dotInspect.vinNoLabel')" class="text-left mb-0">
                                                    <b-form-input type="text" :placeholder="$t('dotInspect.vinNoPlaceholder')" class="unit f-14"
                                                        v-model="recordPayload.vin_no" required></b-form-input>
                                                    <p v-if="errors && errors.vin_no" class="field-error">
                                                        {{ errors.vin_no[0] }}
                                                    </p>
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                        </b-row>
                                        <b-row class="align-items-center px-4 mb-3 mt-5 d-block">
                                        <h3 class="f-18 font-weight-bold col-12 text-left mb-0">{{ $t('dotInspect.inspectorSection') }}</h3>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <div class="text-left select_arrow ">
                                                <b-form-group :label="$t('dotInspect.inspectorLabel')" class="text-left mb-0">
                                                    <b-form-input type="text" :placeholder="$t('dotInspect.inspectorPlaceholder')"
                                                        class="unit f-14" v-model="recordPayload.inspector"
                                                        required></b-form-input>
                                                    <p v-if="errors && errors.inspector" class="field-error">
                                                        {{ errors.inspector[0] }}
                                                    </p>
                                                </b-form-group>
                                            </div>
                                        </b-col>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <div class="text-left mb-2">
                                                <label for="modal-smart-drop-plus-datepicker" class="state">{{ $t('dotInspect.dateLabel') }}</label>
                                                <date-picker v-model="recordPayload.date" :formatter="momentFormat"
                                                    :range-separator="' - '" @clear="recordPayload.date = ''"
                                                    :placeholder="$t('dotInspect.selectDate')" class="date-picker-custom f-14"
                                                    :teleport="'body'"></date-picker>
                                            </div>
                                        </b-col>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <b-form-checkbox id="checkbox-privacy" name="checkbox-privacy"
                                                class="text-left mt-3" v-model="recordPayload.certify">
                                                <span class="font-weight-normal">
                                                    {{ $t('dotInspect.certifyText') }}
                                                </span>
                                                <p v-if="errors && errors.certify" class="field-error">
                                                    {{ errors.certify[0] }}
                                                </p>
                                            </b-form-checkbox>
                                        </b-col>
                                        <b-col md="6" sm="12" class="mt-5">
                                            <div class="d-flex">
                                                <div class="text-right modal-footer border-0 p-0">
                                                    <b-button class="mx-0 mr-3 h-40px w-100px" @click="$router.push('/')"
                                                        variant="secondary">{{ $t('dotInspect.cancel') }}</b-button>
                                                    <b-button class="mx-0 h-40px" @click="generatePdf" variant="primary"
                                                        :disabled="isGenerating">
                                                        {{ isGenerating ? $t('dotInspect.generating') : $t('dotInspect.generatePdf') }}
                                                    </b-button>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal id="modal-document" centered :footer-class="'d-block border-0 pt-0 pb-3 m-0'" no-close-on-backdrop
            size="lg" :body-class="'px-3 pt-2 overflow-preview-auto'" no-close-on-esc :header-class="'align-items-center'"
            scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('dotInspect.documentTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    {{ $t('dotInspect.closeModal') }}
                </b-button>
                <b-dropdown id="dropdown-preview" class="load-dropdown mt-0">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button class="mb-2"
                        @click="downloadDoc(documentData.id, `${recordPayload.unit_no}-${documentData.description ? documentData.description : ''}`)">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('dotInspect.download') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="showPopup(documentData.id)">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('dotInspect.delete') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col lg="4" sm="12">
                        <div class="text-left mb-3">
                            <label for="modal-datepicker" class="state">{{ $t('dotInspect.dateLabel') }}</label>
                            <date-picker v-model="documentData.date" :formatter="momentFormat" :range-separator="' - '"
                                @clear="documentData.date = ''" :placeholder="$t('dotInspect.selectDate')" class="date-picker-custom"
                                :teleport="'body'"></date-picker>
                            <p v-if="docErrors && docErrors.date" class="field-error">
                                {{ docErrors.date[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label for="modal-expiry-date" class="state">{{ $t('dotInspect.expiryDateLabel') }}</label>
                            <date-picker v-model="documentData.expiry_date" :formatter="momentFormat"
                                :range-separator="' - '" @clear="documentData.expiry_date = ''" :placeholder="$t('dotInspect.selectDate')"
                                class="date-picker-custom" :teleport="'body'"></date-picker>
                            <p v-if="docErrors && docErrors.expiry_date" class="field-error">
                                {{ docErrors.expiry_date[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('dotInspect.typeLabel') }}</label>
                            <b-form-select class="f-12" :options="getDotOptions" v-model="documentData.doc_type"
                                @change="setDocDescription($event)">
                            </b-form-select>
                            <p v-if="docErrors && docErrors.doc_type" class="field-error">
                                {{ docErrors.doc_type[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('dotInspect.descriptionLabel') }}</label>
                            <b-form-textarea id="textarea" :placeholder="$t('dotInspect.descriptionPlaceholder')" rows="3"
                                v-model="documentData.description"></b-form-textarea>
                            <p v-if="docErrors && docErrors.description" class="field-error pb-4">
                                {{ docErrors.description[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('dotInspect.driverLabel') }}</label>
                            <b-form-checkbox v-model="documentData.driver" name="check-button" switch size="lg"
                                class="ml-0-6rem" />
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('dotInspect.dotModeLabel') }}</label>
                            <b-form-checkbox v-model="documentData.dot_mode" name="check-button" switch size="lg"
                                class="ml-0-6rem" />
                        </div>
                        <div class="text-left">
                            <label class="state">{{ $t('dotInspect.publicLabel') }}</label>
                            <b-form-checkbox v-model="documentData.public" name="check-button" switch size="lg"
                                class="ml-0-6rem" />
                        </div>
                    </b-col>
                    <b-col lg="8" sm="12">
                        <div>
                            <div class="review-media-section overflow-hidden">
                                <iframe class="w-100 h-100 border-0" :src="media"></iframe>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mt-4">
                    <b-button class="mx-0 h-40px w-100px m-0" @click="resetDocumentData()" variant="secondary"
                        :class="hasDocChanged ? 'mr-3' : ''">{{ $t('dotInspect.close') }}</b-button>
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="sendDocumentData"
                        v-if="hasDocChanged">{{ $t('dotInspect.save') }}</b-button>
                </div>
            </template>
        </b-modal>
        <DeleteModal :message="$t('dotInspect.deleteDocConfirm')" v-if="showDocumentModal"
            @confirm="deleteDocumentItem($event)" />
    </b-container>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapGetters, mapActions } from 'vuex';
import DeleteModal from "@/components/DeleteModal.vue";
import * as moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { generateDotInspectionPdf } from '@/services/generateDotInspectionPDF';
import { checkValueExists, checkDescriptionLength } from "@/services/helper";

export default {
    name: "DotInspect",
    data() {
        return {
            nameOptions: [],
            errors: {},
            docErrors: {},
            defaultDocsData: {},
            checkValueExists,
            checkDescriptionLength,
            media: null,
            showDocumentModal: false,
            documentData: {
                id: null,
                object_id: null,
                date: null,
                type: null,
                document: null,
                description: null,
                expiry_date: "",
                driver: true,
                public: false,
                dot_mode: true,
                doc_type: ""
            },
            isGenerating: false,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            recordPayload: {
                inspection_site: '',
                division: '',
                type: '',
                unit_no: '',
                vin_no: '',
                inspector: '',
                date: new Date(),
                certify: false
            }
        }
    },
    components: {
        vSelect,
        DatePicker,
        DeleteModal
    },
    computed: {
        ...mapGetters(['divisions', 'company', 'docTypeItems']),
        equipmentTypeOptions() {
            return [
                { value: '', text: '-' },
                { value: 'Vehicle', text: this.$t('dotInspect.typeVehicle') },
                { value: 'Trailer', text: this.$t('dotInspect.typeTrailer') }
            ]
        },
        hasDocChanged() {
            return Object.keys(this.documentData).filter(field => {
                if (field !== 'updated_at') {
                    if (typeof this.documentData[field] === 'object') return JSON.stringify(this.documentData[field]) !== JSON.stringify(this.defaultDocsData[field])
                    if (field === 'description') {
                        return this.checkValueExists(this.documentData[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n')) != this.checkValueExists(this.defaultDocsData[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n'));
                    }
                    else if (!this.documentData[field] && !this.defaultDocsData[field]) return false
                    else return this.checkValueExists(this.documentData[field]) != this.checkValueExists(this.defaultDocsData[field])
                } return false
            }).length > 0
        },
        getDotOptions() {
            return [...[{
                value: "",
                text: "",
            }], ...this.docTypeItems?.filter((item) => item.model === this.recordPayload?.type || item.model === 'All').map((item) => {
                return {
                    value: item.id,
                    text: item.type,
                }
            })]
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
        selectedUnitLabel() {
            const unit = this.nameOptions.find(item => item.id === this.recordPayload.unit_no);
            return unit?.label || this.recordPayload.unit_no || '';
        },
    },
    methods: {
        ...mapActions(['deleteEquipmentDocument', 'retrieveDocument', 'getFilteredEquipments', 'setNotification', 'setLoader', 'sendEquipmentDocument', 'updateEquipmentDocument']),
        resetDocumentData() {
            this.recordPayload = {
                inspection_site: this.company[0]?.inspection_site_name || '',
                division: this.divisions.filter((item) => item.default)[0]?.id || '',
                type: '',
                unit_no: '',
                vin_no: '',
                inspector: this.company[0]?.inspector_default_name || '',
                date: new Date(),
                certify: false
            }
            this.$bvModal.hide('modal-document');
            this.documentData = {
                id: null,
                object_id: null,
                date: null,
                type: null,
                document: null,
                description: null,
                expiry_date: "",
                driver: true,
                public: false,
                dot_mode: true,
                doc_type: ""
            };
            this.defaultDocsData = JSON.parse(JSON.stringify(this.documentData));
        },
        showPopup() {
            this.showDocumentModal = true;
        },
        async deleteDocumentItem(item) {
            if (item) {
                await this.deleteDocument(this.documentData.id);
            }
            this.showDocumentModal = false;
        },
        async deleteDocument(id) {
            try {
                this.setLoader(true)
                await this.deleteEquipmentDocument(`${id}/?company_id=${this.userCompany}`);
                await this.setNotification({
                    msg: "Document successfully deleted!!",
                    type: "success",
                    color: "green",
                });
                this.$bvModal.hide("modal-document");
                this.documentData = {
                    id: null,
                    object_id: null,
                    date: null,
                    type: null,
                    document: null,
                    description: null,
                    expiry_date: "",
                    driver: true,
                    public: false,
                    dot_mode: true,
                    doc_type: ""
                };
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        async downloadDoc(id, name) {
            this.setLoader(true)
            const doc = await this.retrieveDocument(id);
            fetch(doc.document)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                })
                .then(blob => {
                    const newUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = newUrl;
                    const urlWithoutParams = doc.document.split('?')[0];
                    const extension = urlWithoutParams.split('.').pop();
                    a.download = name + "." + extension
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(newUrl);
                    a.remove()
                    this.setLoader(false)
                })
                .catch(error => {
                    this.setLoader(false)
                    console.log(error)
                });
        },
        setDocDescription(event) {
            if (event) {
                this.documentData.description = this.getDotOptions.filter((option) => option.value === event)[0].text
            }
            else this.documentData.description = this.defaultDocsData.description
        },
        async sendDocumentData() {
            try {
                if (this.documentData.description && this.checkDescriptionLength(this.documentData.description)) {
                    throw {
                        description: ["Ensure this field has no more than 100 characters"],
                    };
                }
                const nullKeys = this.checkNullValues({
                    date: this.documentData.date,
                    document: this.documentData.document,
                    ...this.company[0].doc_type ? { doc_type: this.documentData.doc_type } : {}
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    let formData = new FormData();
                    let fileType = this.documentData.document instanceof File || this.documentData.document instanceof Blob;
                    if (!fileType) this.documentData.document = null
                    formData.append("object_id", this.recordPayload.unit_no);
                    formData.append(
                        "date",
                        moment(this.documentData.date).format("YYYY-MM-DD")
                    );
                    formData.append("type", this.documentData.type);
                    formData.append("description", this.documentData.description);
                    if (this.documentData.doc_type) formData.append("doc_type", this.documentData.doc_type);
                    formData.append("expiry_date", this.documentData.expiry_date ? moment(this.documentData.expiry_date).format("YYYY-MM-DD") : '');
                    if (this.documentData.document) {
                        formData.append(
                            "document",
                            new File(
                                [this.documentData.document],
                                this.recordPayload.unit_no + "_" + this.documentData.description +
                                "_" + this.userCompany + "_" +
                                new Date().getTime() +
                                "." +
                                this.documentData.document["type"].split("/").pop(),
                                { type: this.documentData.document["type"] }
                            )
                        );
                    }
                    formData.append("driver", this.documentData.driver);
                    formData.append("public", this.documentData.public);
                    formData.append("dot_mode", this.documentData.dot_mode);
                    formData.append("model_type", "equipment");
                    formData.append("company_id", parseInt(localStorage.getItem("userSelectedCompany")));
                    this.documentData = await this.updateEquipmentDocument({
                        id: this.documentData.id,
                        payload: formData
                    });
                    this.editDocumentFlag = false;
                    await this.setNotification({
                        msg: "Document Successfully updated!!",
                        type: "success",
                        color: "green",
                    });
                    this.resetDocumentData()
                    this.setLoader(false);
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = ["This field is required."];
                    });
                    throw error;
                }
            } catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.docErrors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        resetUnitNo() {
            this.recordPayload.unit_no = '';
            this.recordPayload.vin_no = '';
            this.nameOptions = [];
        },
        setVinNo(data) {
            this.recordPayload.vin_no = this.nameOptions.find((item) => item.id === data)?.vin_no || ''
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        /**
         * Format date to YYYY-MM-DD for PDF generation
         */
        formatDateForPdf(date) {
            if (!date) return '';
            return moment(date).format('YYYY-MM-DD');
        },
        docTypeExists() {
            // First try to find the specific annual inspection type based on equipment type
            let docType = null;

            if (this.recordPayload.type === 'Vehicle') {
                docType = this.docTypeItems?.find((item) => item.type === 'Vehicle Annual Inspection');
            } else if (this.recordPayload.type === 'Trailer') {
                docType = this.docTypeItems?.find((item) => item.type === 'Trailer Annual Inspection');
            }

            // Fall back to Default if no specific type found
            if (!docType) {
                docType = this.docTypeItems?.find((item) => item.type === 'Default');
            }

            return docType ? docType : null;
        },
        async generatePdf() {
            try {
                this.errors = {}
                const nullKeys = this.checkNullValues({
                    inspection_site: this.recordPayload.inspection_site,
                    division: this.recordPayload.division,
                    type: this.recordPayload.type,
                    unit_no: this.recordPayload.unit_no,
                    vin_no: this.recordPayload.vin_no,
                    inspector: this.recordPayload.inspector,
                    date: this.recordPayload.date,
                    certify: this.recordPayload.certify
                });

                if (nullKeys.length > 0) {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = ["This field is required."];
                    });
                    throw error;
                }

                this.isGenerating = true;
                this.setLoader(true);
                const divisionData = this.divisions.find((item) => item.id === this.recordPayload.division);
                const pdfFields = {
                    type: this.recordPayload.type,
                    carrier_name: divisionData?.name || '',
                    carrier_address: divisionData?.address || '',
                    carrier_city: divisionData?.city || '',
                    carrier_state: divisionData?.state_obj?.name || '',
                    carrier_zip: divisionData?.zipcode || '',
                    unit_number: this.selectedUnitLabel,
                    vin: this.recordPayload.vin_no || '',
                    inspection_name: this.recordPayload.inspector || '',
                    inspection_date: this.formatDateForPdf(this.recordPayload.date),
                    inspection_site: this.recordPayload.inspection_site || '',
                    certified: this.recordPayload.certify
                };


                const pdfBytes = await generateDotInspectionPdf(pdfFields);

                // Create filename with type, unit number and date
                const typeLabel = this.recordPayload.type === 'Vehicle' ? 'Vehicle' : 'Trailer';
                const dateStr = moment(this.recordPayload.date).format('YYYY-MM-DD');
                const filename = `DOT_Inspection_${typeLabel}_${this.selectedUnitLabel}_${dateStr}.pdf`;

                const formData = new FormData();
                formData.append("object_id", this.recordPayload.unit_no);
                formData.append('document', new Blob([pdfBytes], { type: 'application/pdf' }), filename);
                formData.append('description', this.docTypeExists() ? this.docTypeExists().type :'Dot Inspection');
                formData.append(
                    "date",
                    moment(this.recordPayload.date).format("YYYY-MM-DD")
                );
                formData.append("driver", true);
                formData.append("dot_mode", true);
                formData.append(
                    "expiry_date",
                    moment(this.recordPayload.date).add(1, 'year').format("YYYY-MM-DD")
                );
                if (this.docTypeExists()) formData.append("doc_type", this.docTypeExists().id);
                formData.append("model_type", "equipment");
                formData.append("company_id", parseInt(localStorage.getItem("userSelectedCompany")));
                const data = await this.sendEquipmentDocument(formData);
                this.media = URL.createObjectURL(new Blob([pdfBytes], { type: 'application/pdf' }));
                this.documentData = {
                    id: data.doc_id,
                    object_id: this.recordPayload.unit_no,
                    date: this.recordPayload.date,
                    description: this.docTypeExists() ? this.docTypeExists().type :'Dot Inspection',
                    type: '',
                    doc_type: this.docTypeExists() ? this.docTypeExists().id : null,
                    expiry_date: moment.tz(this.recordPayload.date, this.userTimeZone).add(1, 'year').toDate(),
                    driver: true,
                    public: false,
                    dot_mode: true,
                    document: new Blob([pdfBytes], { type: 'application/pdf' })
                }
                this.defaultDocsData = JSON.parse(JSON.stringify(this.documentData));
                this.$bvModal.show('modal-document');
                this.setNotification({
                    msg: 'DOT Inspection PDF generated successfully!',
                    type: 'success',
                    color: 'green'
                });


            } catch (error) {
                console.error('PDF generation error:', error);
                if (typeof error === "object" && !error.message) {
                    // Validation errors
                    this.errors = error;
                } else {
                    this.setNotification({
                        msg: error.message || 'Failed to generate PDF. Please try again.',
                        type: 'error',
                        color: 'red'
                    });
                }
            } finally {
                this.isGenerating = false;
                this.setLoader(false);
            }
        },
        async searchAssets(searchText) {
            if (searchText) {
                let options = []
                const equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText, type: this.recordPayload.type });
                equipmentRecords.map((item) => {
                    options.push({
                        id: `${item.id}`,
                        label: item.unit_no,
                        vin_no: item.vin_no
                    });
                });
                this.nameOptions = [...new Map(options.map(item => [item['id'], item])).values()]
            }
        },
    },
    mounted() {
        this.recordPayload.inspection_site = this.company[0]?.inspection_site_name || ''
        this.recordPayload.inspector = this.company[0]?.inspector_default_name || ''
        this.recordPayload.division = this.divisions.filter((item) => item.default)[0]?.id || ''
    }
};
</script>
<style>
.date-picker-custom.f-14 .mx-input-wrapper .mx-input {
    font-size: 14px !important;
}
</style>